import cx from "classnames";
import React from "react";

import { ProductEntity } from "@/mk2/apps/bazaar/schemas";
import { ImgCropMode, ImgCropped } from "@/mk2/components/ImgCropped";
import { Link } from "@/mk2/components/Link";
import { productSlugToArray } from "@/mk/bazaar/product/utils";
import { bazaar_single_page_item_detail_url } from "@/mk/urls/functions";

import styles from "./ProductCoverImage.mscss";

interface OwnProps {
    className?: string;
    product: ProductEntity;
    alt?: string;
    size?: number;
    innerRef?: React.Ref<HTMLAnchorElement>;
}

type Props = OwnProps;

const ProductCoverImage = React.memo<Props>(({ className, product, alt, size = 50, innerRef }) => (
    <Link
        className={cx(styles.ProductCoverImage, className)}
        to={bazaar_single_page_item_detail_url(...productSlugToArray(product.slug))}
        innerRef={innerRef}
    >
        <ImgCropped
            photo={product.photos[0].photofile}
            photoVersion="s221x221"
            className={styles.ProductCoverImage__image}
            alt={alt}
            width={size}
            height={size}
            mode={ImgCropMode.Cover}
        />
    </Link>
));

ProductCoverImage.displayName = "ProductCoverImage";

export default ProductCoverImage;
